module.exports = __webpack_public_path__ + "assets/img/scenic_06.8af0b70e.svg";